import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const HomesAndGardens: Site = {
  id: 'homesandgardens',
  logo: 'svg/homesandgardens.svg',
  label: 'Homes & Gardens',
  analyticsName: 'homesandgardens',
  hostname: 'homesandgardens.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
